import React from 'react';
import {Button} from '@tickchak/react-share/app';
import AiGenerate from '../../../assets/icons/aiGenerate';
import * as css from './AIGeneratorButton.css';
import EventRolePermission from '../../../pages/components/rolePermission/EventRolePermission';

interface AIGeneratorButtonProps {
    label: string;
    onClick: () => void;
    'data-cy'?: string;
    'data-testid'?: string;
    cssStyle?: string;
}

function AIGeneratorButton({label, onClick, 'data-cy': dataCy, 'data-testid': dataTestId, cssStyle = ''}: AIGeneratorButtonProps) {
    
    return (
        <EventRolePermission rolePermission='manage event'>
            <css.triggerWrapper $cssStyle={cssStyle}>
                <Button
                    onClick={onClick}
                    data-cy={dataCy ?? 'ai-generator-trigger'}
                    data-testid={dataTestId}
                    iconStart={<AiGenerate inverse />}
                    size="category"
                    variant="brand"
                >
                    {label}
                </Button>
            </css.triggerWrapper>
        </EventRolePermission>
    );
}

export default AIGeneratorButton;
